const NO_REGIONAL_NAME = 'sem regional';

function isNoRegionalSentinel(name) {
  return String(name || '').trim().toLowerCase() === NO_REGIONAL_NAME;
}

export const ASSET_TAG_DEFS = [
  { id: 'company', labelKey: 'header.company', field: 'companyName' },
  { id: 'regional', labelKey: 'header.regional', field: 'regionalName' },
  { id: 'installation', labelKey: 'header.installation', field: 'installationName' },
];

export function buildAssetTags(registrationData) {
  const data = registrationData || {};
  return ASSET_TAG_DEFS
    .map(({ id, labelKey, field }) => {
      const value = data[field];
      return {
        id,
        labelKey,
        value: (id === 'regional' && isNoRegionalSentinel(value)) ? '' : value,
      };
    })
    .filter(tag => Boolean(tag.value));
}
